// PageVariablesApolices.js

export const pageVariables = {
    headers: [
        'NOME',
        'STATUS'
    ],
    headerInfo: {
        "title": "Rotas",
        "description": "Esta seção fornece informações detalhadas sobre os agendamentos, incluindo dados como o segurado, data e hora da visita, consultor responsável e status do agendamento. Acompanhe e gerencie os agendamentos realizados para garantir que as visitas aos segurados sejam realizadas conforme o planejado e cumpram os objetivos estabelecidos."
    }, 
    inputs: [
       
    ],
    agendadores: [
      ],
    seguradosFilterPage: process.env.VUE_APP_API_URL+"segurados/FilterCount",
    agendadoresPage: process.env.VUE_APP_API_URL+"get-group-members/agendadores",
    consultoresPage: process.env.VUE_APP_API_URL+"get-group-members/consultores",
    page: process.env.VUE_APP_API_URL+"agendamentos",
    agendamentoAvulso: process.env.VUE_APP_API_URL+"agendamentos/avulso",
    getAgendamentosPage: process.env.VUE_APP_API_URL+"getAgendamentos",
    empresasSelectpage: process.env.VUE_APP_API_URL+"empresas/select",
};
